import { Fragment } from "react";
import { Button, Container } from "reactstrap";
import { H5, Image } from "../../../AbstractElements";
import CountdownData from "./CountdownData";
import { Link } from "react-router-dom";

const ComingBgImg = () => {
  return (
    <Fragment>
      <div className="page-wrapper" id="pageWrapper">
        {/* <!-- Page Body Start--> */}
        <Container fluid={true} className="p-0 m-0">
          <div className="comingsoon comingsoon-bgimg">
            <div className="comingsoon-inner text-center">
              <a href="/">
                <Image
                  attrImage={{
                    src: `${require("assets/logo.jpg")}`,
                    alt: "",
                    width: 120,
                  }}
                />
              </a>
              <H5>Đang hoàn thành</H5>
              <div className="countdown" id="clockdiv">
                <CountdownData />
              </div>
              <Link to="/">
                <Button className="btn-primary">Trang chủ</Button>
              </Link>
            </div>
          </div>
        </Container>
      </div>
    </Fragment>
  );
};

export default ComingBgImg;
